import {NgModule} from "@angular/core";
import {ArticleComponent} from "./article.component";
import {CommonModule} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import { SafeHtmlModule } from "@app/pipes/safe-html/safe-html.module";

@NgModule({
    declarations: [ArticleComponent],
    exports: [
        ArticleComponent
    ],
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    SafeHtmlModule

  ]
})
export class ArticleModule{}
